export const normalizeAddress = (address) => address && address.toLowerCase();
